// src/pages/AdminPage.jsx
import * as React from 'react';
import { Container, Box } from '@mui/material';
import Navbar from '../components/Navbar';
import AdminNavbar from '../components/admin/Navbar'; // attention au nom du fichier: "navbar.jsx"
import Footer from '../components/Footer';
import { Outlet } from 'react-router-dom';

export default function AdminPage() {
  return (
    <>
      {/* Navbar globale */}
      <Navbar />

      {/* Contenu principal */}
      <Box sx={{ bgcolor: '#f7faf8', minHeight: '100vh', py: 1 }}>
        <Container maxWidth="lg">
          {/* Sous-navbar admin */}
          <Box sx={{ mb: 3 }}>
            <AdminNavbar />
          </Box>

          {/* 👉 Zone dynamique : produits / transactions (selon la route) */}
          <Outlet />
        </Container>
      </Box>

      <Footer />
    </>
  );
}